import React, { Component } from "react";
import { connect } from "react-redux";
import { addSettings } from "../../../actions";
import { getClientOutboundSBCDetails } from "./../../../config/forms_api_calls";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import dateFormat from "dateformat";

const auth = new HelperClass();

class SBCSettings extends Component {
  constructor() {
    super();
    this.state = {
      sbcAccount: null,
      sbcRateDecks: [],
      sbcLoading: true,
      sbcError: null,
      sbcRateDeckOpenIndex: null,
    };
  }

  async componentDidMount() {
    await this.fetchSBCDetails();
  }

  fetchSBCDetails = async () => {
    this.setState({ sbcLoading: true, sbcError: null });
    try {
      const res = await getClientOutboundSBCDetails(
        auth.getClientAccount(),
        auth.getClientToken()
      );
      if (!res.data.success) {
        this.setState({
          sbcLoading: false,
          sbcError: res.data.message || "Failed to load SBC account details",
        });
        return;
      }
      this.setState({
        sbcLoading: false,
        sbcAccount: res.data.account || null,
        sbcRateDecks: res.data.rateDecks || [],
        sbcError: null,
      });
    } catch (e) {
      this.setState({
        sbcLoading: false,
        sbcError: "Unable to reach server. Please try again.",
      });
    }
  };

  render() {
    const { sbcLoading, sbcError, sbcAccount, sbcRateDecks } = this.state;

    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings &&
          this.props.defaultSettings.is_msa_signed === "No" ? (
            <MsaWarning />
          ) : null}
          {this.props.defaultSettings &&
          this.props.defaultSettings.is_client_settings_exist === "No" ? (
            <SettingsError />
          ) : null}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <PageTitle
                      name="SBC Settings"
                      icon="icon ni ni-signal"
                    />
                  </div>
                </div>
              </div>

              <div className="nk-block">
                <div className="card card-bordered">
                  <div className="card-inner">

                    {/* Loading */}
                    {sbcLoading ? (
                      FormLoader()
                    ) : (
                      <>
                        {/* Error */}
                        {sbcError && (
                          <div className="alert alert-pro alert-danger mb-4">
                            <div className="alert-text">
                              <h6>Error</h6>
                              <p>{sbcError}</p>
                            </div>
                          </div>
                        )}

                        {/* Account content */}
                        {!sbcError && sbcAccount && (
                          <>
                            {/* MY ACCOUNT INFORMATION */}
                            <div className="card card-bordered mb-4">
                              <div className="card-inner">
                                <p
                                  className="overline-title text-base pb-2 border-bottom"
                                  style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}
                                >
                                  MY ACCOUNT INFORMATION
                                </p>
                                <div className="row g-3">
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Customer ID</span>
                                    <span className="lead-text">{sbcAccount.account_id || "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Account Name</span>
                                    <span className="lead-text">{sbcAccount.account_name || "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Group</span>
                                    <span className="lead-text">{sbcAccount.group_name || "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Contact</span>
                                    <span className="lead-text">{sbcAccount.contact || "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Email</span>
                                    <span className="lead-text">{sbcAccount.email || "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Date Added</span>
                                    <span className="lead-text">
                                      {sbcAccount.date_added
                                        ? dateFormat(sbcAccount.date_added, "mmm dd, yyyy")
                                        : "—"}
                                    </span>
                                  </div>
                                  {sbcAccount.address && (
                                    <div className="col-12 col-md-8">
                                      <span className="sub-text">Address</span>
                                      <span className="lead-text">
                                        {[
                                          sbcAccount.address.address,
                                          sbcAccount.address.city,
                                          sbcAccount.address.state,
                                          sbcAccount.address.zip,
                                          sbcAccount.address.country,
                                        ].filter(Boolean).join(", ") || "—"}
                                      </span>
                                    </div>
                                  )}
                                  {sbcAccount.phone_book && sbcAccount.phone_book.business && (
                                    <div className="col-6 col-md-4">
                                      <span className="sub-text">Phone (Business)</span>
                                      <span className="lead-text">{sbcAccount.phone_book.business}</span>
                                    </div>
                                  )}
                                  {sbcAccount.phone_book && sbcAccount.phone_book.mobile && (
                                    <div className="col-6 col-md-4">
                                      <span className="sub-text">Phone (Mobile)</span>
                                      <span className="lead-text">{sbcAccount.phone_book.mobile}</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* ACCOUNT STATUS */}
                            <div className="card card-bordered mb-4">
                              <div className="card-inner">
                                <p
                                  className="overline-title text-base pb-2 border-bottom"
                                  style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}
                                >
                                  ACCOUNT STATUS
                                </p>
                                <span
                                  style={{
                                    color: sbcAccount.status === "Enabled" ? "#1ee0ac" : "#e85347",
                                    fontWeight: 600,
                                    fontSize: "14px",
                                  }}
                                >
                                  {sbcAccount.status || "—"}
                                </span>
                              </div>
                            </div>

                            {/* SETTINGS */}
                            <div className="card card-bordered mb-4">
                              <div className="card-inner">
                                <p
                                  className="overline-title text-base pb-2 border-bottom"
                                  style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}
                                >
                                  SETTINGS
                                </p>
                                <div className="row g-3">
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">CPS Limit</span>
                                    <span className="lead-text">{sbcAccount.limit_cps != null ? sbcAccount.limit_cps : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Ports (Sessions)</span>
                                    <span className="lead-text">{sbcAccount.limit_sessions != null ? sbcAccount.limit_sessions : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Initial Billing Increment</span>
                                    <span className="lead-text">{sbcAccount.duration_min != null ? sbcAccount.duration_min : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Subsequent Billing Increment</span>
                                    <span className="lead-text">{sbcAccount.duration_inc != null ? sbcAccount.duration_inc : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Billing Type</span>
                                    <span className="lead-text">{sbcAccount.lrn_billing === 1 ? "LRN" : "Standard"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Rounding Digits</span>
                                    <span className="lead-text">{sbcAccount.round_precision != null ? sbcAccount.round_precision : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Rounding Method</span>
                                    <span className="lead-text">
                                      {sbcAccount.round_type === 1 ? "Up"
                                        : sbcAccount.round_type === 2 ? "Down"
                                        : sbcAccount.round_type === 3 ? "Half Up"
                                        : sbcAccount.round_type != null ? sbcAccount.round_type : "—"}
                                    </span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Price Cap (Max Rate)</span>
                                    <span className="lead-text">{sbcAccount.max_rate != null ? sbcAccount.max_rate : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">PP Type</span>
                                    <span className="lead-text">{sbcAccount.pp_type != null ? sbcAccount.pp_type : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">PP Value</span>
                                    <span className="lead-text">{sbcAccount.pp_value != null ? sbcAccount.pp_value : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Routing Mode</span>
                                    <span className="lead-text">{sbcAccount.routing_mode != null ? sbcAccount.routing_mode : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Always Failover</span>
                                    <span className="lead-text">{sbcAccount.always_failover === 1 ? "Yes" : "No"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Failure Codes</span>
                                    <span className="lead-text">{sbcAccount.failure_codes || "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Call Timeout (s)</span>
                                    <span className="lead-text">{sbcAccount.call_timeout != null ? sbcAccount.call_timeout : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Progress Timeout (s)</span>
                                    <span className="lead-text">{sbcAccount.progress_timeout != null ? sbcAccount.progress_timeout : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Max Route Depth</span>
                                    <span className="lead-text">{sbcAccount.max_route_depth != null ? sbcAccount.max_route_depth : "—"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">International</span>
                                    <span className="lead-text">{sbcAccount.international ? "Yes" : "No"}</span>
                                  </div>
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">RTP Blocking</span>
                                    <span className="lead-text">{sbcAccount.rtp_blocking === 1 ? "Yes" : "No"}</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* STIR/SHAKEN */}
                            <div className="card card-bordered mb-4">
                              <div className="card-inner">
                                <p
                                  className="overline-title text-base pb-2 border-bottom"
                                  style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}
                                >
                                  STIR/SHAKEN
                                </p>
                                <div className="row g-3">
                                  <div className="col-6 col-md-4">
                                    <span className="sub-text">Default Attestation</span>
                                    <span className="lead-text">
                                      {sbcAccount.stir_shaken_def_attest === 1 ? "A"
                                        : sbcAccount.stir_shaken_def_attest === 2 ? "B"
                                        : sbcAccount.stir_shaken_def_attest === 3 ? "C"
                                        : sbcAccount.stir_shaken_def_attest != null ? sbcAccount.stir_shaken_def_attest : "—"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* RATE DECKS */}
                            <div className="card card-bordered mb-4">
                              <div className="card-inner">
                                <p
                                  className="overline-title text-base pb-2 border-bottom"
                                  style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}
                                >
                                  RATE DECKS
                                </p>
                                {sbcRateDecks.length === 0 ? (
                                  <p className="text-muted">No rate decks found for this account.</p>
                                ) : (
                                  <div className="accordion" id="sbcClientRateDecksAccordion">
                                    {sbcRateDecks.map((rd, idx) => (
                                      <div className="card" key={rd.rd_id || idx}>
                                        <div
                                          style={{ cursor: "pointer", background: "#f5f6fa", padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                          onClick={() => this.setState({ sbcRateDeckOpenIndex: this.state.sbcRateDeckOpenIndex === idx ? null : idx })}
                                        >
                                          <span style={{ fontWeight: 600, fontSize: "13px", color: "#364a63", wordBreak: "break-all" }}>
                                            <em className="icon ni ni-file-text" style={{ marginRight: "8px" }}></em>
                                            {rd.filename || ("Rate Deck #" + rd.rd_id)}
                                          </span>
                                          <em
                                            className={"icon ni " + (this.state.sbcRateDeckOpenIndex === idx ? "ni-chevron-up" : "ni-chevron-down")}
                                            style={{ flexShrink: 0 }}
                                          ></em>
                                        </div>
                                        {this.state.sbcRateDeckOpenIndex === idx && (
                                          <div className="card-inner" style={{ paddingTop: "12px" }}>
                                            <div className="row g-3">
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">RD ID</span>
                                                <span className="lead-text">{rd.rd_id != null ? rd.rd_id : "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Enabled</span>
                                                <span className="">
                                                  {rd.enabled === 1
                                                    ? <span className="badge badge-outline-success">Yes</span>
                                                    : <span className="badge badge-outline-danger">No</span>}
                                                </span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">International</span>
                                                <span className="lead-text">{rd.international === 1 ? "Yes" : "No"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Date Created</span>
                                                <span className="lead-text">
                                                  {rd.date_created ? dateFormat(rd.date_created, "mmm dd, yyyy") : "—"}
                                                </span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Carrier Effective Day</span>
                                                <span className="lead-text">
                                                  {rd.carrier_effective_day ? dateFormat(rd.carrier_effective_day, "mmm dd, yyyy") : "—"}
                                                </span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Toll Free</span>
                                                <span className="lead-text">
                                                  {(rd.in_toll_free === "1" || rd.in_toll_free === 1)
                                                    ? ("Yes (" + rd.toll_free_price + ")")
                                                    : "No"}
                                                </span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Areas</span>
                                                <span className="lead-text">{rd.areas || "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">RD Type</span>
                                                <span className="lead-text">{rd.rd_type != null ? rd.rd_type : "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Price Priority</span>
                                                <span className="lead-text">{rd.price_priority != null ? rd.price_priority : "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Min Margin</span>
                                                <span className="lead-text">{rd.min_margin != null ? rd.min_margin : "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Max Margin</span>
                                                <span className="lead-text">{rd.max_margin != null ? rd.max_margin : "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Rounding Precision</span>
                                                <span className="lead-text">{rd.rounding_persicion != null ? rd.rounding_persicion : "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Rounding Type</span>
                                                <span className="lead-text">{rd.rounding_type != null ? rd.rounding_type : "—"}</span>
                                              </div>
                                              <div className="col-6 col-md-4">
                                                <span className="sub-text">Use Carrier Restrictions</span>
                                                <span className="lead-text">{rd.use_carrier_restrictions === 1 ? "Yes" : "No"}</span>
                                              </div>
                                              {rd.rd_type === 3 && (
                                                <>
                                                  <div className="col-6 col-md-4">
                                                    <span className="sub-text">Flat Rate Price</span>
                                                    <span className="lead-text">{rd.flatrate_price != null ? rd.flatrate_price : "—"}</span>
                                                  </div>
                                                  <div className="col-6 col-md-4">
                                                    <span className="sub-text">Flat Rate Column</span>
                                                    <span className="lead-text">{rd.flatrate_columm || "—"}</span>
                                                  </div>
                                                  <div className="col-6 col-md-4">
                                                    <span className="sub-text">Flat Rate Digit</span>
                                                    <span className="lead-text">{rd.flatrate_digit || "—"}</span>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SBCSettings);
